import styles from './styles.module.less'
import { WarpedComposition } from "@/components/Composition/WarpedComposition"
import { PropertySetSelect } from "../../common/PropertySetSelect"
import { IUnitData } from "@/services/project/modal"
import { ManualInputRow } from "../../common/ManualInputRow"
import { LabelRow } from '../../common/LabelRow'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '@/store'
import { addManualInputThunk, deleteManualInputThunk } from '@/store/flowsheet/actions'
import { getFlowSimulationSelector } from '@/store/flowsheet/flowsheet.slice'

interface MainVars {
  unitId: string
  data: IUnitData | undefined
  reloadData?: () => void
}

export function StreamMainTab(props: MainVars) {
  const {unitId, data, reloadData} = props
  const flowSimulation = useSelector(getFlowSimulationSelector)
  const outData = data?.vars?.OUT || {} as any
  const dispatch = useDispatch<AppDispatch>()

  const onCompositionChange = async (val: number[]) => {
    dispatch(addManualInputThunk({
      data: {dvars: [{unitId, attribute: ':OUT:xi_$1', value: val}]},
      params: {sId: flowSimulation?.id}
    }))
  }

  const onCompositionDelete = async () => {
    dispatch(deleteManualInputThunk({
      data: {dvars: [{unitId, attribute: ':OUT:xi_$1'}]},
      params: {sId: flowSimulation?.id}
    }))
  }

  return <div className={styles.container}>
    <ManualInputRow label="Molar Flow" dimCode='MOL_F' data={outData.F} attrKey=':OUT:F' unitId={unitId} reload={reloadData}/>
    <ManualInputRow label="Mass Flow" dimCode='MASS_F' data={outData.M} attrKey=':OUT:M' unitId={unitId} reload={reloadData}/>
    <ManualInputRow label="Pressure" dimCode='PRES' data={outData.P} attrKey=':OUT:P' unitId={unitId} reload={reloadData}/>
    <ManualInputRow label="Temperature" dimCode='TEMP' data={outData.T} attrKey=':OUT:T' unitId={unitId} reload={reloadData}/>
    {outData.VF === 'SC' && <LabelRow className={styles.manualInputRow} label="Molar Vapor Fraction" value="Supercritical" />}
    {outData.VF !== 'SC' && <ManualInputRow label="Molar Vapor Fraction" dimCode='PF' data={outData.VF} attrKey=':OUT:VF' unitId={unitId} reload={reloadData}/>}
    <WarpedComposition className="mt-1" setName={data?.args?.tpps} value={outData.xi_$1} onChange={onCompositionChange} onDelete={onCompositionDelete}/>
    <ManualInputRow label="Enthalpy" dimCode='MOL_H' data={outData.h} attrKey=':OUT:h' unitId={unitId} reload={reloadData}/>
    <ManualInputRow label="Entropy" dimCode='MOL_S' data={outData.s} attrKey=':OUT:s' unitId={unitId} reload={reloadData}/>
    <PropertySetSelect unitId={unitId} value={data?.args?.tpps} onChanged={reloadData} />
  </div>
}